import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'sslValidUntil'
})
export class SslValidUntilPipe implements PipeTransform {
    transform(sslValidUntil?: Date | string | null) {
        if (sslValidUntil === null) {
            return '';
        }

        const formattedExpiryDate = new Date(sslValidUntil);
        const oneWeekToGo = new Date();
        const twoWeeksToGo = new Date();

        oneWeekToGo.setDate(oneWeekToGo.getDate() + 7);
        twoWeeksToGo.setDate(twoWeeksToGo.getDate() + 14);

        if (formattedExpiryDate <= oneWeekToGo) {
            return 'text-danger'
        } else if (formattedExpiryDate <= twoWeeksToGo) {
            return 'text-warning'
        } else {
            return 'text-success'
        }
    }
}
